import React, { Component } from "react";
import { connect } from "react-redux";
import { FormItem, ButtonItem, round2Decimals, dineroDisabledMask } from "../../../../../Components/Items";
import { Form as FormInitial, Row, Col, Tooltip, Popconfirm } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import SelectVentasItem from "../../../../../Components/SelectVentasItem";

class TabAnticipos extends Component {
  state = {
    //Saldo de cada anticipo por su id, no por posicion: al quitar un renglon los indices se
    //recorren y el saldo terminaria pegado al anticipo equivocado
    saldosPorAnticipo: {},
  };

  guardarSaldo(venta) {
    if (!venta?._id) return;

    const saldo = venta.saldoAnticipo !== undefined && venta.saldoAnticipo !== null
      ? venta.saldoAnticipo
      : round2Decimals((venta.totalPagar || 0) - (venta.totalPagadoAnticipos || 0));

    this.setState((prevState) => ({
      saldosPorAnticipo: {
        ...prevState.saldosPorAnticipo,
        [venta._id.toString()]: saldo,
      },
    }));
  }

  //Mismo reparto que hace el backend en agregarVenta: de cada anticipo se toma solo lo que
  //falta por cubrir, en el orden en el que se seleccionaron

  calcularAplicaciones(anticiposSeleccionados) {
    const totalVenta = round2Decimals(this.props.totalVenta || 0);
    let restantePorCubrir = totalVenta;

    const aplicaciones = (anticiposSeleccionados || []).map((valueAnticipo) => {
      const ventaId = valueAnticipo?.ventaId ? valueAnticipo.ventaId.toString() : null;

      if (!ventaId) return { ventaId: null, saldo: null, aplicado: 0 };

      const saldo = this.state.saldosPorAnticipo[ventaId];

      if (saldo === undefined) return { ventaId, saldo: null, aplicado: 0 };

      const aplicado = round2Decimals(Math.min(saldo, restantePorCubrir));
      restantePorCubrir = round2Decimals(restantePorCubrir - aplicado);

      return { ventaId, saldo, aplicado };
    });

    return {
      aplicaciones,
      totalAplicado: round2Decimals(totalVenta - restantePorCubrir),
      restantePorCubrir,
      totalVenta,
    };
  }

  render() {
    const { empresaId, headersToken } = this.props;

    return (
      <div style={{ padding: "8px" }}>
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) => {
            const clienteId = getFieldValue("clienteId");
            if (!clienteId) {
              return (
                <p style={{ color: "#999", textAlign: "center", marginTop: 24 }}>
                  Primero elige el cliente
                </p>
              );
            }

            const { aplicaciones, totalAplicado, restantePorCubrir, totalVenta } =
              this.calcularAplicaciones(getFieldValue("anticiposSeleccionados"));

            return (
              <FormInitial.List name="anticiposSeleccionados">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ name }, arrayKey) => {
                      const aplicacion = aplicaciones[arrayKey];

                      return (
                        <Row key={arrayKey} gutter={8} align="middle" style={{ marginBottom: 8 }}>
                          <Col span={22}>
                            <FormItem
                              name={[name, "ventaId"]}
                              fieldKey={[arrayKey, "ventaId"]}
                              required
                              margin
                              noStyle
                            >
                              <SelectVentasItem
                                empresaId={empresaId}
                                headersToken={headersToken}
                                clienteId={clienteId}
                                anticipos={true}
                                style={{ width: "100%" }}
                                placeholder="Seleccionar anticipo"
                                onChange={(value, venta) => this.guardarSaldo(venta)}
                              />
                            </FormItem>
                            {aplicacion?.saldo !== null && aplicacion?.saldo !== undefined && (
                              <div style={{ fontSize: 12, color: "#888", paddingLeft: 4 }}>
                                Saldo del anticipo: {dineroDisabledMask(aplicacion.saldo)} · Se aplica a esta venta:{" "}
                                <span style={{ color: aplicacion.aplicado > 0 ? "#2b8a3e" : "#c92a2a" }}>
                                  {dineroDisabledMask(aplicacion.aplicado)}
                                </span>
                                {aplicacion.aplicado > 0 && aplicacion.aplicado < aplicacion.saldo
                                  ? ` · Le queda ${dineroDisabledMask(round2Decimals(aplicacion.saldo - aplicacion.aplicado))}`
                                  : ""}
                                {aplicacion.aplicado === 0 && totalVenta > 0
                                  ? " · La venta ya quedo cubierta, quita este anticipo"
                                  : ""}
                              </div>
                            )}
                          </Col>
                          <Col span={2}>
                            <div className="acciones-container">
                              <Popconfirm
                                title="¿Quitar este anticipo?"
                                onConfirm={() => remove(name)}
                                okText="Sí"
                                cancelText="No"
                              >
                                <Tooltip title="Quitar">
                                  <ButtonItem
                                    rojo2
                                    icon={<DeleteOutlined />}
                                    size="small"
                                    lessTime
                                  />
                                </Tooltip>
                              </Popconfirm>
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                    {fields.length > 0 && (
                      <div style={{ marginTop: 10, paddingTop: 8, borderTop: "1px solid #f0f0f0", fontSize: 13 }}>
                        <div>
                          Total de la venta: <b>{dineroDisabledMask(totalVenta)}</b>
                        </div>
                        <div>
                          Se aplica de anticipos: <b>{dineroDisabledMask(totalAplicado)}</b>
                        </div>
                        <div>
                          Queda por cobrar: <b>{dineroDisabledMask(restantePorCubrir)}</b>
                        </div>
                      </div>
                    )}
                    <div style={{ textAlign: "center", marginTop: 10 }}>
                      <ButtonItem
                        type="primary"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                        lessTime
                      >
                        Agregar Anticipo
                      </ButtonItem>
                    </div>
                  </>
                )}
              </FormInitial.List>
            );
          }}
        </FormItem>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(TabAnticipos);
